/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react'
import LineChart from '../../../../components/charts/LineChart'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import WeeklyBreakdownTable from '../table/WeeklyBreakdownTable'
import {KpiCardsContainer} from '../card'
import {chartOptions} from '../../utils'
import {ProfitTrendModalProps} from '../../types'

const ProfitTrendModal = ({
  onClose,
  entityId,
  entityName,
  onProfitTrendIdChange,
  isProfitTrendDataLoading,
  profitTrendChartData,
  kpiData,
  weeklyBreakdownData,
}: ProfitTrendModalProps) => {
  useEffect(() => {
    onProfitTrendIdChange(entityId)
  }, [entityId])

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      title={
        <div>
          <h2>6-Month Profit Trend</h2>
          <h3 className='text-muted fs-6 fw-normal mt-1'>{entityName}</h3>
        </div>
      }
      dialogClassName='modal-dialog modal-xl mw-1200px'
      disableAction={true}
      bodyClass='mh-700px overflow-auto p-5'
      disableFooter={true}
      isLoading={isProfitTrendDataLoading}
      body={
        <>
          {/* KPI Cards */}
          <KpiCardsContainer kpiData={kpiData} />

          {/* Chart */}
          <div className='mb-10'>
            <div className=' border-0 pt-6'>
              <h3 className='card-title fw-bold ms-2'>Weekly Profit Trend</h3>
            </div>
            <div className='position-relative d-flex align-items-center min-h-400px py-2'>
              <LineChart data={profitTrendChartData} options={chartOptions} />
            </div>
          </div>

          {/* Weekly Breakdown Table */}
          <div>
            <div className='border-0 pt-6'>
              <h3 className='card-title fw-bold ms-2 mb-2'>Weekly Breakdown</h3>
            </div>
            <div className='p-2'>
              <WeeklyBreakdownTable data={weeklyBreakdownData} loading={isProfitTrendDataLoading} />
            </div>
          </div>
        </>
      }
    />
  )
}

export default ProfitTrendModal
